import { ISifRowsCodesStatus } from '../../types';

export const getFormattedSifRowsCodes = (sifRowsCodes: ISifRowsCodesStatus) => [
    {
        title: 'Unrecognized Codes',
        bgColor: '#EF5350',
        codes: sifRowsCodes.unrecognizedCodes
    },
    {
        title: 'Missing Required Codes',
        bgColor: '#FF9800',
        codes: sifRowsCodes.requiredButMissingCodes
    },
    {
        title: 'Recognized Codes',
        bgColor: '#2E7D32',
        codes: sifRowsCodes.recognizedCodes
    }
];
